export const jpSubmitResetAdmin = {
  CA50submitResetAdmin: '送信する',
}
